import React, { useState } from "react";

import "./useDialog.css";  // import styles

export function useDialog() {
  const [state, setState] = useState({
    open: false,
    type: null, // "alert" or "confirm"
    message: "",
    resolve: null
  });

  const alert = (message) =>
    new Promise((resolve) => {
      setState({ open: true, type: "alert", message, resolve });
    });

  const confirm = (message) =>
    new Promise((resolve) => {
      setState({ open: true, type: "confirm", message, resolve });
    });

  const handleClose = (result) => {
    state.resolve(result);
    setState({ ...state, open: false });
  };

  const Dialog = () =>
    state.open ? (
      <div className="modal-overlay">
        <div className="modal">
          <p>{state.message}</p>
          {state.type === "alert" && (
            <button onClick={() => handleClose(true)}>OK</button>
          )}
          {state.type === "confirm" && (
            <div className="modal-buttons">
              <button onClick={() => handleClose(true)}>OK</button>
              <button onClick={() => handleClose(false)}>Cancel</button>
            </div>
          )}
        </div>
      </div>
    ) : null;

  return { alert, confirm, Dialog };
}